"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tooltip = void 0;
var tooltip = {
  margin: {
    "default": '0'
  },
  fontWeight: {
    "default": '400'
  },
  padding: {
    leftRight: '0 0.4rem',
    topBottom: '0.4rem 0'
  },
  fontFamily: {
    "default": '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"'
  },
  fontSize: {
    "default": '0.875rem'
  }
};
exports.tooltip = tooltip;